import { useState, useEffect } from 'react';
import { addToQueue } from '../../api/spotify.api';

const storageKey = (roomId) => `queuebar:queue:${roomId}`;

export function useQueue(roomId, onAvailableChange) {
  const [queue, setQueue] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey(roomId));
      return saved ? JSON.parse(saved) : [];
    } catch {
      return [];
    }
  });
  const [sending, setSending] = useState(false);
  const [sendError, setSendError] = useState(null);

  // Persiste la selección para que sobreviva a un refresh de la página.
  useEffect(() => {
    try {
      localStorage.setItem(storageKey(roomId), JSON.stringify(queue));
    } catch {
      /* localStorage no disponible: se ignora */
    }
  }, [queue, roomId]);

  const add = (song) => {
    if (navigator.vibrate) navigator.vibrate(12);
    setQueue((prev) => (prev.some((s) => s.uri === song.uri) ? prev : [...prev, song]));
  };

  const remove = (uri) => setQueue((prev) => prev.filter((s) => s.uri !== uri));

  const reorder = (next) => setQueue(next);

  const send = async () => {
    if (queue.length === 0 || sending) return;
    setSending(true);
    setSendError(null);
    try {
      let lastAvailable;
      let firstError;
      for (const song of queue) {
        try {
          const data = await addToQueue(roomId, song);
          if (data?.available !== undefined) lastAvailable = data.available;
        } catch (err) {
          if (!firstError)
            firstError = err.response?.data?.message ?? 'Error al agregar canción';
        }
      }
      setQueue([]);
      if (lastAvailable !== undefined) onAvailableChange(lastAvailable);
      if (firstError) setSendError(firstError);
      else if (navigator.vibrate) navigator.vibrate([18, 50, 18]);
    } finally {
      setSending(false);
    }
  };

  return { queue, sending, sendError, add, remove, reorder, send };
}
